<template>
  <main class="repayment-dialog" v-if="repayList.loanDate">
    <header class="title">
      <p>
        {{ repayList.loanDate }}借￥<span>{{
          $utils.toYuan(repayList.loanAmount)
        }}</span>
        | <span>分{{ repayList.totalPeriod }}期</span>
      </p>
    </header>
    <div class="content-wrapper">
      <section
        class="info normal-bg"
        :class="{ 'danger-bg': repayList.status === 3 }"
      >
        <div v-if="repayList.status === 1 || repayList.status === 3">
          <p>
            截止今日待还总额(元)<span
              v-if="repayList.status === 3"
              class="info-overdue"
              >已逾期</span
            >
          </p>
          <h3 class="number-medium info-momeny">
            {{ $utils.toYuan(repayList.notYetRepayAmount) }}
          </h3>
          <p class="info-princial">
            本金{{ $utils.toYuan(repayList.notYetRepayPrincipal) }}元 | 利息{{
              $utils.toYuan(repayList.notYetRepayInterest)
            }}元
          </p>
        </div>
        <div class="paid-off" v-if="repayList.status === 2">已还清</div>
      </section>
      <section class="list-wrapper">
        <ul>
          <li
            :class="{ 'moneny-paid-off': repayList.status === 2 }"
            v-for="(item, index) in repayList.repayPlanList"
            :key="index"
          >
            <h3 class="list-title">
              <span class="duration">{{ item.period }}<i>期</i></span
              ><span
                ><span class="number-medium momeny ">{{
                  $utils.toYuan(item.repayAmount)
                }}</span
                ><span class="small-momey"> 元</span></span
              >
            </h3>
            <div
              class="momeny-list"
              :class="{
                'border-left': index != repayList.repayPlanList.length - 1,
              }"
            >
              <span
                class="principal"
                v-if="index !== repayList.repayPlanList.length - 1"
                >利息{{ $utils.toYuan(item.repayInterest) }}元</span
              >
              <span
                class="principal"
                v-if="index === repayList.repayPlanList.length - 1"
                >本金{{ $utils.toYuan(item.repayPrincipal) }}元+利息{{
                  $utils.toYuan(item.repayInterest)
                }}元</span
              >
              <span v-if="item.overdueStatus != 1"
                >扣款日 {{ item.repayDate }}</span
              >
              <p v-if="repayList.status === 2">
                <span class="repay-status paid-off-status">已还清</span>
              </p>
              <p v-else>
                <span class="overdue-color" v-if="item.overdueStatus == 1"
                  >已逾期3天,请尽快还款</span
                >
                <span
                  class="repay-status overdue-color"
                  v-if="item.overdueStatus == 1 && item.status == 1"
                  >逾期</span
                >
                <span
                  class="repay-status"
                  v-if="item.status == 1 && item.overdueStatus == 2"
                  >待还</span
                >
                <span
                  class="repay-status paid-off-status"
                  v-if="item.status == 2 && item.overdueStatus == 2"
                  >已还清</span
                >
              </p>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </main>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('loan', ['repayList']),
  },
  props: {
    assetsId: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.repayment-dialog
  margin-top -16px
  .title
    font-size 18px
  .content-wrapper
    .info
      padding 36px 32px
      box-shadow 0 6px 20px 0 rgba(220,223,230,0.28)
      border-radius 4px 4px 0 0
      color white
      box-sizing border-box
      .info-overdue
        background white
        font-size 7px
        color error-color
        margin-left 10px
        width 32px
        height 14px
        border-radius 2px
        padding 3px
        box-sizing border-box
    .paid-off
      font-size 32px
      margin-top 36px
    .normal-bg
      background-image linear-gradient(13deg, #41485D 0%, #4C5872 100%)
      .info-momeny
        font-size 40px
        margin 8px 0 20px 0
      .info-princial
        opacity: 0.8
        font-size 18px
        color #FFFFFF;
        line-height 14px
    .danger-bg
      background error-color
  .list-wrapper
    padding 24px 32px
    border 1px solid #F0F0F0
    ul
      li
        margin-bottom 15px
        .list-title
          margin-bottom 12px
          color #333333
          display flex
          .duration
            margin-right 16px
            font-size 22px
            i
              font-size 16px
              font-style normal
          .momeny
            font-size 24px
            font-family DINPro-Medium
          .small-momey
            font-size 12px
        .momeny-list
          position relative
          display flex
          flex-direction column
          font-size 12px
          color gray04
          line-height 12px
          padding-left 28px
          margin-left 15px
          height 56px
          .principal
            margin-bottom 8px
          .repay-status
            position absolute
            right 48px
            top 4px
            font-size 14px
          .paid-off-status
            color gray05
          .overdue-color
            color error-color
        .border-left
          border-left 1px solid #E1E1E1
      .moneny-paid-off
        span
          color gray04
</style>
